module.exports = __webpack_public_path__ + "static/media/Twitter_Logo_WhiteOnBlue.d00ce219.svg";